import React, { useEffect, useState } from "react";
import SearchSelectBox from "../SearchSelectBox";
import { EmploymentStatus, employmentStatusNaming, RegisteredPosition, registeredPositionNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";
import { getClubDepartments } from "../../api/club";
import { useSelector } from "react-redux";
import { isEmpty } from "../../common/StaticExports";

const DepartmentAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const [departmentList, setDepartmentList] = useState([]);
    const currentClub = useSelector((state:any) => state.clubDetails);

    const fetchDepartmentList = async () => {
        const response = await getClubDepartments({ clubId: currentClub?.id });
        setDepartmentList(response);
    }
    useEffect(() => {
        currentClub && currentClub?.id && fetchDepartmentList();
    }, [selectedValues]);

    const manageDepartmentSelect = (d:any) => {
      let tempDepts = [];
      const index = selectedValues.findIndex((item:any) => item == d.id);
      if(index !== -1) {
        tempDepts = selectedValues.filter((item:any) => item != d.id);
      } else {
        tempDepts = [...selectedValues, String(d.id)];
      }
      manageSelect(tempDepts);
    }

    return (
        <>
            <AutoComplete 
            options={departmentList}
            selectedValues={selectedValues}
            handleMenuClick={manageDepartmentSelect} 
            label={t('DC_5_DEPARTMENT')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            isError={isEmpty(selectedValues)}
            errorMessage={t('REQUIRED')}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default DepartmentAutocomplete;